export default {
  title: "IMAGETEXT.XYZ Blog",

  author: "ImageText.xyz Support",
  description:
    "Guides, tips, and insights on OCR, image-to-text conversion, and breaking language barriers — powered by imagetext.xyz.",

  indexPageSize: 10,
};
